export enum Pipeline {
  LEGACY = "legacy",
  MISTRAL = "mistral",
}
